<template>
	<div class="general">
		<div class="general-width">
			<h1>
				This is a home page
			</h1>
		</div>
	</div>
</template>
